import { COMPONENT_HEADER_HEIGHT, COMPONENT_HEADER_HEIGHT_EMPHASIZED } from '../../config'

export function getComponentHeights(emphasizeHeader?: boolean, hasHeader = true) {
  const headerHeight = emphasizeHeader ? COMPONENT_HEADER_HEIGHT_EMPHASIZED : COMPONENT_HEADER_HEIGHT
  const contentHeight = hasHeader ? `calc(100% - ${headerHeight}px)` : '100%'
  return { headerHeight, contentHeight }
}
